import PropTypes from 'prop-types';
import { useState } from 'react';
import { NavLink as RouterLink, useLocation } from 'react-router-dom';

// @mui
import {
  Box,
  List,
  ListItemText,
  Collapse
} from '@mui/material';

import { ExpandLess, ExpandMore, Padding } from '@mui/icons-material';
// styles
import { StyledNavItem, StyledNavItemIcon } from './styles';

// ----------------------------------------------------------------------

NavSection.propTypes = {
  data: PropTypes.array,
};

export default function NavSection({ data = [], ...other }) {
  return (
    <Box {...other}>
      <List disablePadding sx={{ p: 1 }}>
        {data.map((item) =>
          item.children ? (
            <NavItemCollapse key={item.title} item={item} />
          ) : (
            <NavItem key={item.title} item={item} />
          )
        )}
      </List>
    </Box>
  );
}

// ----------------------------------------------------------------------

NavItem.propTypes = {
  item: PropTypes.object,
};

function NavItem({ item, isChild = false, childsx }) {
  const { title, path, icon, info } = item;

  return (
    <StyledNavItem
      component={RouterLink}
      to={path}
      sx={{
      
        ...(isChild && {
          ml: 1,
         ...childsx,
          // px: '10px !important',
          // py: '2px !important',
          // minHeight: '28px !important',
          // px: isChild ? 0.5 : 2.5,
          // py: isChild ? 0.5 : 1,
          // minHeight: isChild ? 32 : 44,

          '& .MuiListItemText-root': {
            margin: 0,
          },
        }),
        '&.active': {
          color: 'text.primary',
          bgcolor: isChild ? 'action.hover' : 'action.selected',
        },
         
      }}
    >
      <StyledNavItemIcon>{icon}</StyledNavItemIcon>

      <ListItemText disableTypography primary={title} />
      {info && info}
    </StyledNavItem>
  );
}

// ----------------------------------------------------------------------

NavItemCollapse.propTypes = {
  item: PropTypes.object,
};

function NavItemCollapse({ item }) {
  const { title, icon, children } = item;
  const { pathname } = useLocation();

  // auto-open if any child route matches
  const isActive = children.some((child) =>
    pathname.includes(child.path)
  );

  const [open, setOpen] = useState(isActive);

  return (
    <>
      <StyledNavItem
        onClick={() => setOpen(!open)}
        sx={{
          ...(isActive && {
            color: 'text.primary',
            mb: 0.5,
            bgcolor: 'action.selected',
            fontSize: 15, 
          }),
        }}
      >
        <StyledNavItemIcon>{icon}</StyledNavItemIcon>

        {/* <ListItemText primary={title} /> */}
        <ListItemText disableTypography primary={title} />
        {open ? <ExpandLess /> : <ExpandMore />}
      </StyledNavItem>

      <Collapse in={open} timeout="auto" unmountOnExit>
        <List disablePadding sx={{
          pl: 3,
          mt: 0.5,
          display: 'flex',
          flexDirection: 'column',
          gap: 0.5,
        }}>
          {children.map((child) => (
           <><NavItem key={child.title} item={child} isChild childsx={{p:'5px', fontSize:'14px'}} /></> 
          ))}
        </List>
      </Collapse>
    </>
  );
}